import React from 'react';

const Fotter = () => {
    return (
        <div>
            <div className='container-fuild mt-5   bg-dark'>
                <h6 className=' italic py-5 text-center text-info'> Hard Work || Dedication || Success</h6>
            </div>
        </div>
    );
};

export default Fotter;